module.exports = __webpack_public_path__ + "static/media/safari-pinned-tab.880b0090.svg";